import { Meal } from "../models/Meal";
import { getMeal } from "../services/api";
import { useCachedFetch, CACHE_DURATIONS } from "../contexts/CacheContext";

// Create a cache key for a specific meal
const createMealCacheKey = (id: string) => `meal-${id}`;

export function useCachedMeal(id: string) {
  const { data, loading, error, refetch } = useCachedFetch<Meal>(
    createMealCacheKey(id),
    () => getMeal(id),
    {
      maxAge: CACHE_DURATIONS.MEAL_DETAIL,
      enabled: !!id, // Only fetch if an ID is provided
    },
  );
  return {
    meal: data,
    loading,
    error: error?.message || null,
    refetch,
  };
}
